export default {
  title: 'Smart Home',
  titleRedirect: '/smarthome',
  items: [],
  signing: false,
  checkout: false,
};
